import React from 'react'
import './Animation.css'

class Animation extends React.Component {
  state = {
    visible: this.props.delay === 0
  }

  componentDidMount() {
    if(this.props.delay > 0)
      this.timeout = setTimeout(() => this.setState({ visible: true }), this.props.delay)
  }

  componentWillUnmount() {
    if(this.props.delay > 0)
      clearTimeout(this.timeout)
  }

  render() {
    return (
      <React.Fragment>
      {this.state.visible &&
        <div className={`Animation anim-${this.props.name}${this.props.reverse ? '-reverse' : ''}`}>
          {this.props.children}
        </div>
      }

      {!this.state.visible &&
        <div style={{ opacity: '0' }}>
          {this.props.children}
        </div>
      }
      </React.Fragment>
    )
  }
}

Animation.defaultProps = {
  name: 'fade',
  delay: 0
}

export default Animation


// WEBPACK FOOTER //
// ./src/components/library/animation/Animation.js